// src/hooks/banks/useRestoreBank.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreBank } from "../../api/apiBanks";
import { useTranslation } from "react-i18next";

function useRestoreBank() {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    const { mutate: restoreBankMutation, isPending: isRestore } = useMutation({
        mutationFn: restoreBank,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["banks"] });
            toast.success(isArabic ? "تم استعادة البنك بنجاح" : "Bank restored successfully");
        },
        onError: (err) => {
            toast.error(err?.message || (isArabic ? "فشل في استعادة البنك" : "Failed to restore bank"));
        },
    });

    return { restoreBank: restoreBankMutation, isRestore };
}

export default useRestoreBank;
